import { Record } from 'immutable';

const EssayRecord = Record({
  name: undefined,
  studentId: undefined,
  submitBy: undefined,
  submitDate: undefined,
  essay: undefined,
  comment: undefined,
  commentBy: undefined,
  commentDate: undefined,
  status: undefined,
  statusDisplayName: undefined,
});

class Essay extends EssayRecord {}

export default Essay;



// WEBPACK FOOTER //
// ./data/WritingAssignment/Essay/model.js